import http from "./http";
import { AxiosResponse } from "axios";

export default class UserService {
  async getUserInfo(): Promise<any> {
    try {
      const response: AxiosResponse = await http.get(
        `${process.env.REACT_APP_BASE_URL}users/me`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async setUserOption(value: string): Promise<any> {
    try {
      const response: AxiosResponse = await http.post(
        `${process.env.REACT_APP_BASE_URL}users/events`,
        {
          event: 'ANSWER',
          value: value
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
